<template>
  <div class="material-box">
    <Material class="material-component"></Material>
  </div>
</template>

<script>
import Material from "./../../components/materialSelection"
export default {
    components: {Material},
    data(){
        return{
            
        }
    },
    mounted() {
    },
    methods:{

    },
};
</script>

<style lang="less">
// @import url("../../assets/less/material/material.less");
/*.material-box{
  max-width: calc(100vw - 150px);
  overflow-x: hidden;
}*/
</style>